// className'larni birlashtiradi: falsy qiymatlar tashlab yuboriladi.
export function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

// aria-describedby uchun id'larni yig'adi (hint/error + tashqaridan berilgan).
export function describedBy(...ids) {
  const value = ids.filter(Boolean).join(' ');
  return value || undefined;
}
